import { getCookie, setCookie } from 'h3';

export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute();
  const event = nuxtApp.ssrContext?.event;
  if (!event) return;

  const features = useRuntimeConfig().public.featureFlags;

  // TROLLEY FLAG
  const trolleyQuery = route.query.enableNewTrolleyJourney as string | undefined;
  if (trolleyQuery) {
    setCookie(event, 'enableNewTrolleyJourney', trolleyQuery);
  }

  const trolleyPreference =
    trolleyQuery ||
    (getCookie(event, 'enableNewTrolleyJourney') as string) ||
    (features.enableNewTrolleyJourney.toString() as string | undefined);

  features.enableNewTrolleyJourney = trolleyPreference === 'true';

  // CHECKOUT FLAG
  const checkoutQuery = route.query.enableNewCheckoutFlow as string | undefined;

  if (checkoutQuery) {
    setCookie(event, 'enableNewCheckoutFlow', checkoutQuery);
  }

  const checkoutPreference =
    checkoutQuery ||
    (getCookie(event, 'enableNewCheckoutFlow') as string) ||
    (features.enableNewCheckoutFlow.toString() as string | undefined);

  features.enableNewCheckoutFlow = checkoutPreference === 'true';
});
